import { DataSourceType } from "@coeff/api";
import { DataSourceTypeDisplayNames } from "@coeff/utils";
import * as React from "react";
import styled from "styled-components";

import { COLORS } from "../constants";

import { Alert } from "./Alert";
import { AlertExclamation } from "./Icons";

/**
 * Matches the `StyledAlert` each OAuth settings page declares for its own alerts, so this
 * banner keeps sitting flush with the error and warning ones around it.
 */
const StyledAlert = styled(Alert)<{ $marginBottom?: string }>`
  line-height: 1.8em;
  padding: 12px;

  code {
    white-space: nowrap;
    background-color: ${COLORS.black4};
    padding: 4px 6px;
  }

  .ant-alert-icon {
    margin: 6px;
  }

  ${({ $marginBottom }) => ($marginBottom ? `margin-bottom: ${$marginBottom};` : "")}
`;

/**
 * The "this connector is set up" banner at the top of an OAuth settings page.
 *
 * Eleven call sites had hand-copied this alert, and the description had drifted into two
 * phrasings split by connector rather than by page -- Looker managed to disagree with
 * itself across its own setup and manage pages. Deriving both lines from the data source
 * type keeps a new connector page from inventing a twelfth wording.
 */
export const OAuthConfiguredAlert: React.FC<{
  dataSourceType: DataSourceType;
  $marginBottom?: string;
}> = ({ dataSourceType, $marginBottom }) => {
  const displayName = DataSourceTypeDisplayNames[dataSourceType] ?? dataSourceType;
  return (
    <StyledAlert
      type="info"
      showIcon
      icon={<AlertExclamation type="info" />}
      message={`${displayName} OAuth has been configured for your domain`}
      description={`Connect to ${displayName} using this OAuth configuration by opening the Coefficient sidebar from your spreadsheet.`}
      $marginBottom={$marginBottom}
    />
  );
};
